angular
    .module('logbook')
    .directive('scheduleContainer',['$timeout', '$http', '$q', function ($timeout, $http, $q)
    {
        return {
            restrict: 'E',
			template: require('./scheduler-container.html'),
			
            scope: {
                onBind: '=',
                selectedLog: '=',
                buttonsRight: '=?',
                onlyOne: '=?'
            },

            link: function(scope, elem, attr)
            {
                var shiftPromise;
                var pendingPromise = undefined;

                scope.buttonsRight = attr.hasOwnProperty('buttonsRight');
                scope.onlyOne = attr.hasOwnProperty('onlyOne');

                scope.shifts = undefined;
                scope.model = [];
                scope.supportedTypes = [
                    {
                        displayName: 'Basic Scheduler',
                        name: 'scheduler',
                        htmlTag: 'scheduler',
                        attributes: [
                            {
                                name: 'on-bind',
                                value: 'schedulerBinded'
                            }
                        ]
                    },
                    {
                        displayName: 'Shift Based Scheduler',
                        name: 'shift',
                        htmlTag: 'shift-scheduler',
                        attributes: [
                            {
                                name: 'on-bind',
                                value: 'schedulerBinded'
                            },
                            {
                                name: 'shifts',
                                value: 'shifts'
                            }]
                    }
                ];

                /**
                 * Adds a scheduler of the specified type from the model
                 * @param {string} type - Type of scheduler to add
                 */
                scope.addScheduler = function(type)
                {
                    var modelType = scope.supportedTypes.find(function(value) { return value.name === type });
                    if (modelType === undefined) return;

                    return shiftPromise.then(function()
                    {
                        return $timeout(function()
                        {
                            scope.model.push(Object.assign({
                                parentScope: scope,
                                id: moment().valueOf() // Creates a unique ID to resolve issue with ng-repeat
                            }, JSON.parse(JSON.stringify(modelType))));
                            if (scope.onlyOne === true)
                                $(elem).find('#row-add-schedule-btns').toggleClass('hidden', scope.model.length > 0);

                            return (pendingPromise = $q.defer()).promise;
                        });
                    });

                };

                /**
                 * Removes a scheduler from the listing
                 * @param {object||number} value - Either the object to delete or the index of the object in the model
                 */
                scope.deleteScheduler = function(value)
                {
                    var index = (typeof value === 'number' && scope.model.length > value)
                        ? value
                        : scope.model.findIndex(function(val ) { return val === value });

                    $timeout(function()
                    {
                        if (index >= 0)
                        {
                            scope.model.splice(index, 1);
                            if (scope.onlyOne === true)
                                $(elem).find('#row-add-schedule-btns').toggleClass('hidden', scope.model.length > 0)
                        }

                        scope.onDeleteScheduler();
                    });
                };

                /**
                 * Function passed to schedulers 'onBind' function
                 * @param schedulerScope - The scope of the scheduler
                 */
                scope.schedulerBinded = function(schedulerScope)
                {
                    scope.model.forEach(function(schedulerObj)
                    {
                        if (schedulerObj.scope && schedulerObj.scope.hasOwnProperty('collapseBody'))
                            schedulerObj.scope.collapseBody(true);
                    });

                    scope.model[scope.model.length - 1].scope = schedulerScope;
                    schedulerScope.scheduleName =  scope.model[scope.model.length - 1].displayName;

                    schedulerScope.addOnDeleteEvent(function(schedulerScope)
                    {
                        var val = scope.model.findIndex(function(schedulerObj) { return schedulerObj.scope === schedulerScope });
                        if (!isNaN(val)) scope.deleteScheduler(val);
                    });

                    pendingPromise.resolve(scope.model[scope.model.length - 1]);
                    scope.onAddScheduler();
                };

                /**
                 * Function called when add scheduler button is clicked
                 * @param $event - Event of the target that has a 'scheduler-type' attribute
                 */
                scope.addSchedulerClick = function($event)
                {
                    scope.addScheduler($($event.target).attr('scheduler-type'))
                };

                /**
                 * Loads shifts and sets state of shift button
                 * @return {Promise} - Promise that resolves on shift load
                 */
                scope.loadShifts = function()
                {
                    return $q(function(resolve)
                    {
                        if (!(scope.selectedLog || scope.selectedLog.hasOwnProperty('id')))
                        {
                            scope.shifts = [];
                            scope.setShiftButton(false);
                            resolve();
                        }
                        else
                        {
                            var shiftUrl = 'api/scheduledShifts?log=' + scope.selectedLog.id;
                            $http.get(shiftUrl)
                                .then(function(results)
                                {
                                    scope.setShiftButton((scope.shifts = results.data._embedded.scheduledShifts).length > 0);
                                },
                                function()
                                {
                                    scope.shifts = [];
                                    scope.setShiftButton(false);
                                })
                                .then(function()
                                {
                                    resolve();
                                });
                        }
                    });
                };

                /**
                 * Switches off the loading button and will enable or disable the add shift button
                 * @param {boolean} enabled - Whether the shift button is enabled
                 */
                scope.setShiftButton = function(enabled)
                {
                    $(elem).find('#btn-loading-shift').toggleClass('hidden', true);
                    $(elem).find('#btn-add-shift')
                        .toggleClass('hidden', false)
                        .attr('disabled', !enabled);
                };


                scope.schedulerAdded = [];
                scope.schedulerDeleted = [];
                scope.addOnSchedulerAdded = function(callback)
                {
                    if (typeof callback === 'function') scope.schedulerAdded.push(callback);
                };

                scope.addOnSchedulerDeleted = function (callback)
                {
                    if (typeof callback === 'function') scope.schedulerDeleted.push(callback);
                };

                shiftPromise = scope.loadShifts();

                if (typeof scope.onBind === 'function')
                    scope.onBind(scope);

                scope.onAddScheduler = function()
                {
                    scope.schedulerAdded.forEach(function(callback)
                    {
                        if (typeof callback === 'function') callback(scope);
                    })
                };

                scope.onDeleteScheduler = function()
                {
                    scope.schedulerDeleted.forEach(function(callback)
                    {
                        if (typeof callback === 'function') callback(scope);
                    })
                };
            }
        }
    }]);